<script setup lang="ts">
import { ButtonReload } from '@shared/ui/buttons'

import { useButtonTrackerRefresh } from '../../model/shift-control/button-tracker-refresh.hook'

defineOptions({
  name: 'ButtonTrackerRefresh',
})

const {
  seconds,
  disabled,
  setRefresh,
} = useButtonTrackerRefresh()
</script>

<template>
  <ButtonReload
    :seconds="seconds"
    :disabled="disabled"
    @click="setRefresh"
  />
</template>
